module.exports = __webpack_public_path__ + "img/mgmt_logo_big.8ef3399c.svg";